module.exports = __webpack_public_path__ + "img/entrance.5781f9bd.png";